export const appName = "CHALO KAMAO";

export const isDesktopMediaQueryValue = 992;
